import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehicleAttachments'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehicleAttachmentsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehicleAttachmentsStore",
			variables: true,
		})
	}
}

export async function load_VehicleAttachments(params) {
  await initClient()

	const store = new VehicleAttachmentsStore()

	await store.fetch(params)

	return {
		VehicleAttachments: store,
	}
}
